<template>
  <body>
    <div class="footer">
      <div class="text">© 2023-2026 长光卫星技术股份有限公司 版权所有   |   <span @click="goPrivacyPolicy()" style="cursor: pointer;">隐私协议</span>   |   <span @click="goServiceAgreement()" style="cursor: pointer;">用户服务协议</span>
<!--        |   <span @click="goJl1mall()" style="cursor: pointer;">吉林一号·生态开放商城</span>  -->
      </div>
    </div>
  </body>
</template>

<script>
import $ from "jquery";
export default {
  name: "HomeFooter",
  data() {
    return {

    };
  },
  methods: {
    goJl1mall(){
      window.open("http://jl1mall.com","_self"); //打开一个新的标签页
    },
    goPrivacyPolicy(){
      window.open("http://jl1mall.com/PrivacyPolicy","_self");
    },
    goServiceAgreement(){
      window.open("http://jl1mall.com/ServiceAgreement","_self");

    }
  },

  mounted() {

  },
};
</script>

<style scoped>
.footer{
  position: relative;
  width: 100%;
  height: 120px;
  background-image: url(~@/assets/Home/footer背景.png);
  background-size: 100% 100%;
  /* background: #1A1A1A; */
}
.text{
  position: absolute;
  top: 50px;
  left: calc(50% - 350px);
  width: 700px;
height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 17px;
text-align: center;
}
</style>
